import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Application } from '../../../shared/containers/Application';
import { IApplicationState } from '../../../shared/types/redux';
import { createReduxStore } from '../../../shared/utils/store';
import { IApplicationContext } from '../../../shared/types/application';

interface IDependencies {
  projectName: string;
  initialState: IApplicationState;
  context: IApplicationContext;
}

export function renderApplication({ projectName, initialState, context }: IDependencies) {
  const rootElement = document.getElementById(projectName);
  const store = createReduxStore({ initialState, context, debugEnabled: true });

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(rootElement, <Application context={context} reduxStore={store} />);
}
